import { graphql } from "@/graphql/generated/gql";

// ============== QUERIES ======================
export const getPriorityQueryDocument = graphql(/* GraphQL */ `
  query GetPriority($input: GetPriorityInput!) {
    priority(getPriorityInput: $input) {
      ...PriorityFields
      instanceList {
        ...PriorityInstanceFields
      }
    }
  }
`);

export const getPriorityListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query GetPriorityListForWorkspace($input: GetPriorityListForWorkspaceInput!) {
    priorityListForWorkspace(getPriorityListForWorkspaceInput: $input) {
      ...PriorityFields
      instanceList {
        ...PriorityInstanceFields
      }
    }
  }
`);

// ============== MUTATIONS ======================
export const createPriorityMutationDocument = graphql(/* GraphQL */ `
  mutation createPriority($input: CreatePriorityInput!) {
    createPriority(createPriorityInput: $input) {
      ...PriorityFields
      instanceList {
        ...PriorityInstanceFields
      }
    }
  }
`);

export const updatePriorityMutationDocument = graphql(/* GraphQL */ `
  mutation UpdatePriority($input: UpdatePriorityInput!) {
    updatePriority(updatePriorityInput: $input) {
      ...PriorityFields
      instanceList {
        ...PriorityInstanceFields
      }
    }
  }
`);

export const deletePriorityMutationDocument = graphql(/* GraphQL */ `
  mutation DeletePriority($input: DeletePriorityInput!) {
    deletePriority(deletePriorityInput: $input) {
      ...PriorityFields
      instanceList {
        ...PriorityInstanceFields
      }
    }
  }
`);

export const reorderPriorityMutationDocument = graphql(/* GraphQL */ `
  mutation ReorderPriority($input: ReorderPriorityInput!) {
    reorderPriority(reorderPriorityInput: $input) {
      ...PriorityFields
    }
  }
`);
